import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';

import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import { SITE_LINKS } from '../../constants';
import { GoogleAnalyticsEvents } from '../../enum/GoogleAnalyticsEvents';
import { useGetLesson } from '../../hooks/use-get-lesson';
import { usePlayerPostMessage } from '../../hooks/use-player-post-message';
import { useScreenSize } from '../../hooks/use-screen-size';

export const LessonPage: React.FC = () => {
  const __ = useTranslation().t;

  const path = window.location.pathname.split('/');
  let levelPosition = 0;
  let unitPosition = 0;
  let lessonPosition = 0;
  const levelIndex = path.indexOf('level');
  const unitIndex = path.indexOf('unit');
  const lessonIndex = path.indexOf('lesson');
  if (levelIndex !== -1 && unitIndex !== -1) {
    levelPosition = +path[levelIndex + 1];
    unitPosition = +path[unitIndex + 1];
    lessonPosition = +path[lessonIndex + 1];
  }
  const { lesson, isFetching, isError } = useGetLesson(levelPosition, unitPosition, lessonPosition);
  const { width, screenSizes } = useScreenSize();

  const { listen, stopListening, setActivity } = usePlayerPostMessage();

  useEffect(() => {
    const activity = {
      playerLessonId: lesson?.playerLessonId,
      lessonPosition: lesson?.position,
      unitPosition: lesson?.unitPosition,
      levelPosition: lesson?.levelPosition,
    };
    ReactGA.event(GoogleAnalyticsEvents.LessonOpened, activity);
    if (lessonPosition === 0) {
      ReactGA.event(GoogleAnalyticsEvents.LessonStarted, activity);
    }
    setActivity(activity);
    listen();

    return () => stopListening();
  }, [lesson]);

  if (isError) {
    window.location.href = SITE_LINKS.HomePage;
    return null;
  }

  return (
    <>
      <div className="oejr-page-activity">
        {width >= screenSizes.md && <DefaultHeader activeItem={__('course')} />}
        {isFetching ? (
          <LoadingContainer />
        ) : (
          <iframe id="player" src={lesson?.playerUrl} title="Activity Player" allow="microphone" />
        )}
      </div>
    </>
  );
};
